enum TEAM_ROLE_CODE_NAME {
    OWNER = 'OWNER',
    ADMIN = 'admin',
    USER = 'user',
    DEVICE = 'device'
}

export {
    TEAM_ROLE_CODE_NAME
}
